import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import lifeinsurancelic from "../../assets/life-insurance-lic--250x250.svg";
import { useNotificationActionsContext } from "../../components/notificationModal/useModal";
import { Context } from "../../services/apiContext";
import configData from "../../utils/config/config.json";
import "./css/IpoList.css";
let PageSize = 10;

const IPOListing_filters = ({
  data,

  nextStep,
  prevStep,
  tabPage,
  selectedIpoDetails,
  goToPage,
  onlyApply=true,
}) => {
  // console.log(data);
  const contextapi = useContext(Context);
  const setNotifi = useNotificationActionsContext();
  const openCancelPage = (that) => {
    selectedIpoDetails(that);
    getIPOdetails(that.Symbol, 'cancel');
    // 
   
  };

  const openModifyPage = (that) => {

    selectedIpoDetails(that);    
    getIPOdetails(that.Symbol, 'modify');
   
  };

  let combainData = []
  const getIPOdetails = async (that, type) => {
    var useData = contextapi.getSession("userData").user_key;
    console.log(that);
    var postData = {
      symbol: that,
      user_key: useData,
    };
    var url = "/nse/getipodetails";
    await contextapi
      .postApiAuthCalling(url, postData, true)
      .then((res) => {
        console.log(res);
        if (res[0].status_code === "00") {
          combainData = res[0].IPODetails[0];
          if(res[0].IPODetails[0].Categories[0].Applications.length>0){
            getBidDetails(that,res[0].IPODetails[0].Categories[0].Applications[0].kfin_refno, type);
          }
          
          // 
          console.log(res);
        } else {
          setNotifi({ val: true, msg: res[0].status_desc });
        }
      })
      .catch((error) => {
        setNotifi({ val: true, msg: "Something went wrong -" });
      });
  };

  const getBidDetails = async (that,apprefno,type) => {
    var useData = contextapi.getSession("userData").user_key;
    var url = configData.baseURLProxy;
    var postData = {
      data: {
        "user_key":useData,
        "symbol":that,
        "appl_refno":apprefno
      },
      url: configData.baseURLDev + "/user/getbiddetails",
    };
    await contextapi
      .postApiAuthCalling(url, postData)
      .then((res) => {
        console.log(res);
        if (res.msg === "sucess") {
          combainData.BidingDetails = res.data[0].appl_details[0];
          if(type == "modify"){
            goToPage(7,combainData);
          }else {
            goToPage(6,combainData);
          }
         
        }
      })
      .catch((error) => {
        console.log("Error VerifyUser : ", error);
      });

  };

  const goToPagePage3 = (that) => {
    selectedIpoDetails(that);
    goToPage(3);
  };
  const navigate = useNavigate() 
  const IPODetailsPage = (that) => {
    selectedIpoDetails(that);
    // goToPage(2)
    navigate('/home/IPO/details')
  };

  return (
    <>
      {data.length > 0 &&
        data.map((i, index) => {
          
          const showSummary = i.OpenStatus === "C"
          const showApply = (!showSummary && onlyApply) || i.OpenStatus === "O" && Number(i.ApplCount) === 0
          const showModify = !onlyApply &&  (i.OpenStatus === "O" && i.ApplCount > 0)

          
          return <div className="IPO_list_IndividuaCard" key={index}>
            <div className="row paddingzero">
              {/* <div className="row col-lg-6 col-md-12 col-sm-12 col-12 paddingzero">
                                    <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                                        <div className="innerImageDiveView">

                                            {
                                                i.ipotime == 'new' &&
                                                <div className="postionbadge">
                                                    <div className="badgearrow">New</div>
                                                </div>
                                            }

                                            <img src={lifeinsurancelic} alt="lifeinsu" className="IPOImg" />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                                        <div className="makeitmiddlealign">
                                            <p className="ipoNameValue">{i.ipoName}</p>
                                            <p className="ipodateRange">{i.ipoDate}</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                                        <div className="makeitmiddlealignmore">
                                            <div className={`ipostatus algincenter ${i.status === "Open" ? 'clrgreen' : (i.status === "Closed") ? 'clrorange' : (i.status === "Upcoming") ? 'lightred' : ''}`}>
                                                {i.status}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row col-lg-6 col-md-12 col-sm-12 col-12 paddingzero">


                                    <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                                        <div className="makeitmiddlealign  algincenter">
                                            <p className="ipoNameValue">Quantity</p>
                                            <p className="ipodateRange">{i.quantity}</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                                        <div className="makeitmiddlealign algincenter">
                                            <p className="ipoNameValue">Price Range</p>
                                            <p className="ipodateRange">{i.priceRange}</p>
                                        </div>

                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                                        {
                                            i.status == "Open" &&
                                            <div className="makeitmiddlealignmore algincenter" >
                                                <button className="ipo-list-modify modCanelBtn">Modify</button>
                                                <button className="ipo-list-cancel modCanelBtn">CANCEL</button>
                                            </div>
                                        }

                                        {
                                            i.status == "Closed" &&

                                            <div className="makeitmiddlealignmore algincenter">
                                                <button className="ipo-list-placeorder">PLACE ORDER</button>

                                            </div>
                                        }

                                    </div>
                                </div> */}

              <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="newFlexItems">
                  <div
                    className="innerImageDiveView_new cursorPointer"
                    onClick={() => IPODetailsPage(i)}
                  >
                    {i.ipotime === "new" && (
                      <div className="postionbadge">
                        <div className="badgearrow">New</div>
                      </div>
                    )}

                    <img
                      src={lifeinsurancelic}
                      alt="lifeinsu"
                      className="IPOImg"
                    />
                  </div>
                  <div className="makeitmiddlealign_new">
                    <p className="ipoNameValue">{i.Name}</p>
                    <p className="ipodateRange">
                      {i.BiddingStartDate.split(",")[0]}-
                      {i.BiddingEndDate.split(",")[0]}
                    </p>
                  </div>
{/* 
                  <div className="makeitmiddlealignmore_new">
                    <div
                      className={`ipostatus algincenter mobltop ${
                        i.OpenStatus === "O"
                          ? "clrgreen"
                          : i.OpenStatus === "C"
                          ? "clrorange"
                          : i.OpenStatus === "U"
                          ? "lightred"
                          : ""
                      }`}
                    >
                      {i.OpenStatus === "O"
                        ? "Open"
                        : i.OpenStatus === "C"
                        ? "Closed"
                        : i.OpenStatus === "U"
                        ? "Upcoming"
                        : ""}
                    </div>
                  </div> */}

                </div>
              </div>

              <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="newFlexItems">
                  <div className="  algincenter secondpartFlexfirst">
                    <p className="ipoNameValue">Lot size</p>
                    <p className="ipodateRange">{i.LotSize}</p>
                  </div>

                  <div className=" algincenter  secondpartFlexsecond">
                    <p className="ipoNameValue">Price Range</p>
                    <p className="ipodateRange">
                        ₹  {i.MinPrice}-{i.MaxPrice}
                    </p>
                  </div>

                  <div className="secondpartFlexthird">
                    {showModify && (
                      <div className=" algincenter">
                        <button
                          onClick={() => openModifyPage(i)}
                          className="ipo-list-modify modCanelBtn"
                        >
                          Modify
                        </button>
                        <button
                          onClick={() => openCancelPage(i)}
                          className="ipo-list-cancel modCanelBtn"
                        >
                          CANCEL
                        </button>
                      </div>
                    )}

                    {showSummary && (
                      <div className=" algincenter">
                        <button
                          className="ipo-list-placeorder"
                          onClick={() => goToPagePage3(i)}
                        >
                          VIEW SUMMARY
                        </button>
                      </div>
                    )}

                  {showApply && (
                      <div className=" algincenter">
                        <button
                          className="ipo-list-placeorder"
                          onClick={() => IPODetailsPage(i)}
                        >
                          PLACE ORDER
                        </button>
                      </div>
                  )}

             
                  </div>
                </div>
              </div>
            </div>
          </div>
        })}
      {data.length === 0 && (
        <div className="norecords">
          <p>No {tabPage} IPO Found</p>
        </div>
      )}
    </>
  );
};

export default IPOListing_filters;
